module.exports = __webpack_public_path__ + "static/media/boy (1).f5d31952.png";